module.exports = __webpack_public_path__ + "static/img/a4.37649b0c.png";